/**
 * @generated SignedSource<<ae6229058e71cd4cb19ff68f3651056d>>
 * @relayHash 89edd6d468a6421a2bbdd8f34956e01b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/useNftProfileOwnerRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNftProfileOwnerRefetchQuery$variables = {
  fetchUser?: boolean | null;
  loggedInUserId?: string | null;
};
export type useNftProfileOwnerRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"useNftProfileOwner_viewer">;
  };
};
export type useNftProfileOwnerRefetchQuery = {
  response: useNftProfileOwnerRefetchQuery$data;
  variables: useNftProfileOwnerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "loggedInUserId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "loggedInUserId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNftProfileOwnerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchUser",
                "variableName": "fetchUser"
              },
              {
                "kind": "Variable",
                "name": "loggedInUserId",
                "variableName": "loggedInUserId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "useNftProfileOwner_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNftProfileOwnerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "ethereumWalletAddress",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "loggedInUser",
                "args": (v1/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "canImport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "NFT_IMPORT_CONTRACT_SELF_SERVE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"NFT_IMPORT_CONTRACT_SELF_SERVE\")"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/useNftProfileOwnerRefetchQuery",
    "metadata": {},
    "name": "useNftProfileOwnerRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fa41e893c4f21bd386bab44404c739d5";

export default node;
